import Providers from "@/model/provider/Providers"
import DynamicProviderKey from "@/model/provider/DynamicProviderKey"
import CreditType from "@/model/apply/CreditType"
import { providerState } from "@/state"
import ProviderKey from "@/model/provider/ProviderKey"
import ProductType from "@/model/provider/ProductType"

/**
 * Returns the review route path segment for a given payment plan.
 *
 * @param {object} paymentPlan
 * @param {string} [paymentPlan.providerKey]
 * @param {string} [paymentPlan.providerProductType]
 * @returns {"paymentPlanLoanReview"|"paymentPlanReview"}
 */
export const getReviewPath = (paymentPlan) => {
    const isSynchronyLoanPlan =
        paymentPlan.providerKey?.startsWith(ProviderKey.SYNCHRONY_STANDARD) &&
        paymentPlan.providerProductType === ProductType.LOAN
    return isSynchronyLoanPlan ? "paymentPlanLoanReview" : "paymentPlanReview"
}

export const isFullyCovered = (paymentPlan, financedAmountCents) => {
    const approvedAmount =
        providerState.getApplyResponse(paymentPlan.providerKey)?.approvedAmountCents ||
        providerState.getPreAuthResponse(paymentPlan.providerKey)?.approvedAmountCents
    const planMaxAmount = paymentPlan.maxAmountCents || approvedAmount
    const creditType = Providers[DynamicProviderKey.extractProviderKey(paymentPlan.providerKey)].creditType
    const maxAmount = creditType === CreditType.REVOLVING_CREDIT ? approvedAmount : planMaxAmount
    const maximumMinAmount = paymentPlan.minAmountCents || 0
    return maxAmount >= financedAmountCents && maximumMinAmount <= financedAmountCents
}
